<template>
  <el-tabs class="group_4" v-model="activeTab" style="margin-top:10px">
    <el-tab-pane name="login">
        <template #label>
          <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">账号密码登录</div>
        </template>
        <div class="login-content">
          <div class="login-form">
            <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
              <el-form-item prop="account">
                <el-input 
                  v-model="loginForm.account" 
                  placeholder="请输入您的账号"
                  class="account-input">
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input 
                  v-model="loginForm.password" 
                  placeholder="请输入您的密码"
                  type="password"
                  :show-password="true"
                  class="password-input">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button 
                  @click="handleLogin" 
                  class="login-button"
                  type="primary"
                  :disabled="!isFormValid">
                  登录
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          
          <!-- 其他登录方式：除注册页外展示 -->
          <OtherLoginMethods v-if="activeTab !== 'signup'" />
        </div>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" class="register-form">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:100%;height:48px;">
            <template #prepend>+86</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <div class="code-input-group">
            <el-input v-model="registerForm.email" class="code-input" placeholder="请输入验证码"
              autocomplete="off">
            </el-input>
            <el-button 
              @click="sendSmsCodes" 
              class="get-code-button"
              :disabled="!isRegisterPhoneValid || registerCountdown > 0 || registerSending"
              :loading="registerSending">
              {{ registerCountdown > 0 ? `已发送(${registerCountdown}s)` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            autocomplete="new-password"
            :show-password="true" style="width:100%;height:48px;">
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input v-model="registerForm.confirmPassword" class="pwd_signup" placeholder="请再次输入密码" type="password"
            autocomplete="new-password"
            :show-password="true" style="width:100%;height:48px;">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button 
            @click="register" 
            class="login-button"
            type="primary">
            注册并登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { sendSmsCode } from '@/api/user'
import { businessRegister, businessAccountLogin } from '@/api/login'
import { getPositionList } from '@/api/position'
import { setToken } from '@/store/local/auth'
import OtherLoginMethods from '../components/OtherLoginMethods.vue'
export default {
  components: {
    OtherLoginMethods
  },
  data() {
    return {
      activeTab: 'login',
      loginForm: {
        account: '',
        password: '',
        terminal: 4 // 默认终端类型
      },
      loginRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      registerCountdown: 0,
      registerSending: false,
      registerForm: {
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) callback(new Error('两次输入的密码不一致'))
              else callback()
            }, trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      }
    };
  },
  computed: {
    isFormValid() {
      return this.loginForm.account.trim() !== '' && this.loginForm.password.trim() !== '';
    },
    isRegisterPhoneValid() {
      return this.registerForm.phone.trim() !== '' && /^1[3-9]\d{9}$/.test(this.registerForm.phone);
    }
  },
  // 移除created钩子，由路由守卫处理登录状态检查
  methods: {
    startCountdown(key, seconds = 60) {
      this[key] = seconds;
      const timer = setInterval(() => {
        if (this[key] > 0) this[key] -= 1;
        if (this[key] <= 0) clearInterval(timer);
      }, 1000);
    },
    async sendSmsCodes() {
      if (this.registerCountdown > 0 || this.registerSending) return;
      try {
        this.registerSending = true;
        const response = await sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' });
        if (response.data.code == 1) {
          this.$message.success('验证码已发送，请注意查收');
          this.startCountdown('registerCountdown');
        }
      } finally {
        this.registerSending = false;
      }
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        businessRegister({ account: this.registerForm.phone, password: this.registerForm.password, sms_code: this.registerForm.email, terminal: 4 })
          .then(response => {
            
              if(response.data.code == 1) {
                setTimeout(() => {
                  this.$message.success('注册成功')
                  this.$router.push('/verifyCompany/businessVerification')
                  
                }, 1000)
              }
             
          })
      })
    },
    handleLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (!valid) return;
        
        // 直接使用API调用，不通过Vuex
        businessAccountLogin({
          account: this.loginForm.account,
          password: this.loginForm.password,
          scene: 1,
          terminal: this.loginForm.terminal
        }).then(async response => {
          if (response.data.code === 1) {
            if (response.data.data.is_verified == 0) {
              setToken(response.data.data.token)
              setTimeout(() => {
                // this.$router.push('/store/entry/verifyCompany')
                this.$router.push('/verifyCompany')
              }, 1000)
              return;
            }
            setToken(response.data.data.token)
            // 设置登录状态
            this.$store.dispatch('auth/setLoginStatus', true)
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            const userInfo = await this.$store.dispatch('user/getInfo')
            console.log('userInfo', userInfo);
            
            // 登录后调用岗位列表，按有无数据跳转
            try {
              const positionRes = await getPositionList({ status: 1});
              const hasPositionData = positionRes.data && positionRes.data.data && positionRes.data.data?.lists?.length > 0;
              this.$router.push(hasPositionData ? '/talent' : '/position')
            } catch (e) {
              // 接口异常时，默认正常跳转
              this.$router.push('/talent')
            }
          }
        })
      })
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 全局溢出控制 */
.group_4 {
  overflow: visible;
  max-width: 100%;
  box-sizing: border-box;
}
::v-deep .el-form-item__error {
  left: 40px;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  min-height: 405px;
  height: auto;
  border: none;
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: transparent;
  overflow: visible;
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__active-bar {
  border-radius: 500px;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
  position: relative;
}

::v-deep .el-tabs__nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(101, 101, 135, 0.40);
}

::v-deep .el-tabs__item:nth-child(1) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  position: relative;
}

::v-deep .el-tabs__item:nth-child(1)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: 0px !important;
  position: relative;
}

::v-deep .el-tabs__item:nth-child(2)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: 0px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 48px;
}

::v-deep .phone_login .el-input__inner {
  border-radius: 18px;
}

::v-deep .email_login .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .email_login .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

/* 登录内容容器 */
.login-content {
  padding: 20px 35px;
  background: transparent;
  position: relative;
  z-index: 5;
}

/* 登录表单样式 */
.login-form {
  margin-bottom: 25px;
}

/* 统一注册表单项间距 */
.register-form :deep(.el-form-item) {
  margin-bottom: 16px;
}

.account-input,
.password-input {
  width: 100%;
  margin-bottom: 16px;
}

::v-deep .account-input .el-input__inner,
::v-deep .password-input .el-input__inner {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 16px;
  padding: 0 15px;
}

::v-deep .account-input .el-input__inner:focus,
::v-deep .password-input .el-input__inner:focus {
  border-color: #B16EF9;
  box-shadow: 0 0 0 2px rgba(177, 110, 249, 0.2);
}

.login-button {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  background: #BEBEBE;
  border: none;
  cursor: not-allowed;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.login-button:not(:disabled) {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  cursor: pointer;
}

.login-button:not(:disabled):hover {
  background: linear-gradient(90deg, #6ba3e8 0%, #a55de8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.3);
}

::v-deep .el-form-item {
  margin-bottom: 16px;
}

::v-deep .el-form-item__error {
  left: 0;
  font-size: 14px;
  color: #f56c6c;
}

/* 与手机验证码登录一致的验证码行布局 */
.code-input-group {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.code-input {
  flex: 1;
}

::v-deep .code-input .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

.get-code-button {
  width: 120px;
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
  font-family: "Source Han Sans CN VF";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(0px);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.get-code-button:not(:disabled) span,
.get-code-button:not(:disabled) {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.get-code-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(156, 65, 255, 0.3);
}

.get-code-button:disabled {
  cursor: not-allowed;
}

/* Element UI 会在按钮里包一层 span，这里同步应用文字渐变避免 hover 时被覆盖 */
.get-code-button span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent !important;
}

.get-code-button:not(:disabled) span,
.get-code-button:not(:disabled) {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.get-code-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(156, 65, 255, 0.3);
  background-color: transparent !important; /* 防止库样式覆盖 */
  color: transparent !important;
}

/* 禁用态：保持清晰边界与灰色文字，悬停不变色 */
/* 提升选择器优先级，去掉 !important */
.group_4 .code-input-group .get-code-button.is-disabled,
.group_4 .code-input-group .get-code-button:disabled,
.group_4 .code-input-group .get-code-button.is-disabled:hover,
.group_4 .code-input-group .get-code-button:disabled:hover,
.group_4 .code-input-group .get-code-button.is-disabled:focus,
.group_4 .code-input-group .get-code-button:disabled:focus {
  background: none;
  background-color: #fff; /* 白底，避免透明导致看不清 */
  border: 1px solid #d9d9d9; /* 明显的边框 */
  -webkit-text-fill-color: #bfbfbf;
  color: #bfbfbf; /* 灰色文字 */
  box-shadow: none;
}

/* Element 按钮内部的 span 在禁用时使用灰色文本，移除渐变 */
.group_4 .code-input-group .get-code-button.is-disabled > span,
.group_4 .code-input-group .get-code-button:disabled > span,
.group_4 .code-input-group .get-code-button.is-disabled:hover > span,
.group_4 .code-input-group .get-code-button:disabled:hover > span,
.group_4 .code-input-group .get-code-button.is-disabled:focus > span,
.group_4 .code-input-group .get-code-button:disabled:focus > span {
  background: none;
  -webkit-background-clip: initial;
  background-clip: initial;
  -webkit-text-fill-color: #bfbfbf;
  color: #bfbfbf;
}

/* 强制在各种状态下都使用透明背景，保证文字渐变不丢失 */
.get-code-button,
.get-code-button:hover,
.get-code-button:focus,
.get-code-button:active {
  background-color: transparent !important;
}

</style>